import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On navigation within the admin, jump back to the top of the page (if not
 * already there) so each screen starts at the top rather than inheriting the
 * previous page's scroll position. Scoped to `/admin` routes; the public
 * gallery/marketing pages manage their own scroll (cover hero, anchors).
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!pathname.startsWith("/admin")) return;
    if (typeof window === "undefined") return;
    if (window.scrollY > 0) window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
